<yc-accordion *ngIf="awards?.length"
  [rows]="awards"
  [roundedTopBorders]="false">

  <div class="accordion-header">
    <div class="award-header col-md-6">
      <yc-i18n
        key="common:lblAward"
        defaultValue="Award">
      </yc-i18n>
    </div>
    <div class="col-md-6 payment-header">
      <yc-i18n
        class="flex-grow-1"
        key="common:hdrPayments">
      </yc-i18n>
      <div *ngIf="showAmountToggle" 
        class="globe">
        <yc-button
          [icon]="true"
          [tooltipText]="globeTooltip"
          placement="left"
          (onClick)="toggleAmounts()">
          <yc-fa
            icon="globe"
            [light]="true"
            class="text-link large-icon">
          </yc-fa>
        </yc-button>
      </div>
    </div>
  </div>

  <ng-container *ycAccordionTab="let row;">
    <div class="level-header">
      <!-- Amount -->
      <div class="d-flex">
        <yc-fa 
          [icon]="row.awardType === FundingSourceType.DOLLARS ?
            'money-bill-wave-alt' :
            'gift'"
          [light]="true" 
          class="text-warning icon-header">
        </yc-fa>
        <span class="amount-header">
          <gc-amount-currency-display
            [showInDefault]="showInDefault"
            [amount]="isForApplicantPortal && row.awardType === FundingSourceType.UNITS ?
              null :
              row.amount"
            [equivalent]="isForApplicantPortal && row.awardType === FundingSourceType.UNITS ?
              null :
              row.currencyRequestedAmountEquivalent"
            [currencyRequested]="row.currencyRequested"
            [isPayment]="false"
            [inKindItems]="row.inKindItems"
            [isUnits]="isForApplicantPortal && row.awardType === FundingSourceType.UNITS"
            [amountIsBold]="true">
          </gc-amount-currency-display>
          <small *ngIf="!isForApplicantPortal">
            <yc-i18n
              key="GLOBAL:textAwardId"
              defaultValue="Award ID">
            </yc-i18n>: {{ row.id }}
          </small>
        </span>
        <ng-container *ngIf="isArchived && !isForApplicantPortal">
          (<yc-i18n
            key="GLOBAL:textArchivedLowercase"
            defaultValue="archived">
          </yc-i18n>)
        </ng-container>
      </div>

      <div *ngIf="!isForApplicantPortal">
        <!-- Pending -->
        <span class="detail-row">
          <yc-i18n
            key="common:lblPending">
          </yc-i18n>
          {{
            row.payments |
              ycFilterByAttr: 'statusId': [
                PaymentStatus.Pending,
                PaymentStatus.Scheduled,
                PaymentStatus.Processing,
                PaymentStatus.ProcessingHold
              ] |
              gcPaymentSum: showInDefault: row.currencyRequested: true
          }}
        </span>

        <!-- In Process -->
        <span class="detail-row">
          <yc-i18n 
            key="GLOBAL:textPaid">
          </yc-i18n>:
          {{
            row.payments |
              ycFilterByAttr: 'statusId': [
                PaymentStatus.Outstanding,
                PaymentStatus.Cleared,
                PaymentStatus.Fulfilled
              ] |
              gcPaymentSum: showInDefault: row.currencyRequested: true
          }}
        </span>
      </div>
      
      <div *ngIf="isForApplicantPortal">
        <span class="detail-row">
          <yc-i18n
            [key]="row.payments.length === 1 ?
              'common:textOnePayment' :
              'common:textNumberOfPayments'"
            [context]="{
              number: row.payments.length
            }"
            [defaultValue]="row.payments.length === 1 ?
              '1 payment' :
              '__number__ payments'">
          </yc-i18n>
        </span>
      </div>
    </div>
  </ng-container>

  <ng-container *ycAccordionContent="let row; let awardIndex = index;">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <!-- Award Description -->
      <div class="col-md-9">
        {{ row.description }}
      </div>
      <div *ngIf="!isArchived && canTakeActions && !isForApplicantPortal" 
        class="justify-content-end d-flex">
        <div class="btn-group" dropdown>
          <yc-button dropdownToggle
            [primary]="true"
            [value]="'common:btnOptions' | ycI18n">
            <yc-i18n
              key="AWARDS:textManageAward"
              defaultValue="Manage award">
            </yc-i18n>
            <yc-fa icon="chevron-down" class="ms-2 dropdown-arrow"></yc-fa>
          </yc-button>
          <ul *dropdownMenu
            class="dropdown-menu dropdown-left"
            role="menu">
            
            <!-- Edit Award -->
            <li role="menuitem"
              class="dropdown-item"
              [ycTrackClick]="'Open award modal'"
              (click)="awardModal(row)">
              <yc-fa 
                icon="pencil"
                [light]="true"
                class="text-link me-2">
              </yc-fa>
              <yc-i18n
                key="AWARDS:textEditAward"
                defaultValue="Edit award">
              </yc-i18n>
            </li>

            <!-- Add Payment -->
            <li *ngIf="canAddPaymentMap[row.id]" 
              role="menuitem"
              class="dropdown-item"
              [ycTrackClick]="'Open award modal'"
              (click)="awardModal(row, null, true)">
              <yc-fa 
                icon="plus"
                [light]="true"
                class="text-success me-2">
              </yc-fa>
              <yc-i18n
                key="AWARDS:textAddPayment"
                defaultValue="Add payment">
              </yc-i18n>
            </li>
          
            <!-- Delete Award -->
            <li *ngIf="!row.payments?.length" 
              role="menuitem"
              class="dropdown-item"
              [ycTrackClick]="'Delete award'"
              (click)="deleteAward(row)">
              <yc-fa 
                icon="times"
                [light]="true"
                class="text-danger me-2">
              </yc-fa>
              <yc-i18n
                key="AWARDS:textDeleteAward"
                defaultValue="Delete award">
              </yc-i18n>
            </li>
          </ul>
        </div>

      </div>
    </div>

    <!-- Payments Table -->
    <div class="mb-3">
      <yc-table
        [simple]="true"
        [nonWhiteBackground]="true"
        [rows]="row.payments">
        <!-- Dates  -->
        <ng-container *ycTableColumn="'GLOBAL:hdrDates';
          let row;">
          <gc-payment-dates-block
            [fundingSourceType]="row.typeId"
            [scheduledDate]="row.scheduledDate"
            [issuedDate]="row.issuedDate"
            [isForApplicantPortal]="isForApplicantPortal"
            [clearedDate]="row.clearedDate">
          </gc-payment-dates-block>
        </ng-container>

        <!-- Budget -->
        <ng-container *ycTableColumn="'common:lblBudget';
          visible: !isForApplicantPortal;
          let row;">
          <div *ngIf="!hideFundingSources">
            {{ row.budgetName + ' / ' + row.fundingSourceName }}
          </div>
          <div *ngIf="hideFundingSources">
            {{ row.budgetName }}
          </div>
        </ng-container>

        <!-- Processor -->
        <ng-container *ycTableColumn="'common:textProcessor';
          visible: !isForApplicantPortal;
          let row;">
          <div>
            <ng-container *ngIf="row.processor === ProcessingType.YourCause">
              YourCause
            </ng-container>
            <yc-i18n *ngIf="row.processor === ProcessingType.Client"
              key="common:labelClient"
              defaultValue="Client">
            </yc-i18n>
          </div>
        </ng-container>

        <!-- Amount -->
        <ng-container *ycTableColumn="'GLOBAL:textAmount'; let payment;
          class: 'number'">
          <gc-amount-currency-display
            [showInDefault]="showInDefault"
            [amount]="payment.amount"
            [equivalent]="payment.currencyRequestedAmountEquivalent"
            [currencyRequested]="payment.currencyRequested"
            [showItemPopover]="true"
            [inKindItems]="payment.inKindItems"
            [isPayment]="true"
            [isUnits]="payment.isUnits">
          </gc-amount-currency-display>
        </ng-container>

        <!-- Detail -->
        <ng-container *ycTableColumn="'common:hdrDetail';
          let payment;
          class: 'paymentNumber'">
          <!-- ID -->
          <div *ngIf="!isForApplicantPortal">
            <yc-i18n
              key="MANAGE:hdrPaymentIdDynamic"
              [defaultValue]="'Payment ID:__paymentId__'"
              [context]="{
                paymentId: payment.id
              }">
            </yc-i18n>
          </div>
          <!-- Payment Number -->
          <div *ngIf="payment.paymentNumber">
            <yc-i18n
              key="MANAGE:textPaymentNumber"
              defaultValue="Payment number">
            </yc-i18n>
            {{ payment.paymentNumber }}
          </div>
          <div *ngIf="payment.externalPaymentId">
            <yc-i18n
              key="GLOBAL:textTransactionID"
              defaultValue="Transaction ID">
            </yc-i18n>:
            {{ payment.externalPaymentId }}
          </div>
          
          <!-- Payment Type -->
          <gc-payment-type-display
            [paymentType]="payment.paymentType"
            [paymentStatus]="payment.statusId"
            [isInKind]="payment.isUnits"
            [showPaymentTypePrefix]="true"
            [processorType]="payment.processor">
          </gc-payment-type-display>

          <!-- Batch Name -->
          <div *ngIf="payment.batchName">
            <yc-i18n
              key="MANAGE:textBatchName"
              defaultValue="Batch name">
            </yc-i18n>: {{ payment.batchName }}
          </div>
    
          <gc-reissued-payment-text
            [reissuedInPaymentId]="payment.reissuedInPaymentId"
            [reissuedForPaymentId]="payment.reissuedForPaymentId">
          </gc-reissued-payment-text>
        </ng-container>

        <!-- Status -->
        <ng-container *ycTableColumn="'common:hdrStatus';
          let row;">
          <div>
            <gc-payment-status-block
              [status]="row.status"
              [subStatus]="row.substatus"
              [statusId]="row.statusId"
              [isArchived]="isArchived"
              [statusDate]="row.statusDate"
              [hidePaymentStatus]="isForApplicantPortal && row.hidePaymentStatus"
              [alternatePaymentStatusText]="row.alternatePaymentStatusText"
              [isForApplicantPortal]="isForApplicantPortal"
              [processor]="row.processor"
              [payeeOverride]="row.payeeOverride">
            </gc-payment-status-block>
          </div>
        </ng-container>

        <!-- Actions -->
        <ng-container *ycTableColumn="''; let payment;
          prop: '',
          visible: !isForApplicantPortal,
          filterType: '',
          class: 'actions',
          locked: true">
          <div *ngIf="canTakeActions"
            class="btn-group" dropdown>
            <yc-button dropdownToggle
              [icon]="true"
              [value]="'common:btnOptions' | ycI18n">
              <yc-fa icon="ellipsis-v"></yc-fa>
            </yc-button>
            <ul class="dropdown-menu dropdown-left" *dropdownMenu>
              <!-- Edit Payment -->
              <li class="dropdown-item"
                [ycTrackClick]="'Open award modal'"
                (click)="awardModal(row, payment)">
                <yc-fa
                  [light]="true" 
                  icon="pencil"
                  class="text-link me-2">
                </yc-fa>
                <yc-i18n
                  key="AWARDS:textEditPayment"
                  defaultValue="Edit payment">
                </yc-i18n>
              </li>
              <!-- Delete Payment -->
              <li *ngIf="payment.statusId === PaymentStatus.Pending" 
                class="dropdown-item" 
                [ycTrackClick]="'Delete payment'"
                (click)="deletePayment(row.id, payment.id)">
                <yc-fa 
                  [light]="true"
                  icon="times" 
                  class="text-danger me-2">
                </yc-fa>
                <yc-i18n
                  key="AWARDS:textDeletePayment"
                  defaultValue="Delete payment">
                </yc-i18n>
              </li>
            </ul>
          </div>
        </ng-container>

      <ng-container *ngIf="!isForApplicantPortal">
        <!-- Notes and Designation -->
        <ng-container *ycTableRowFooter="let row;">
          <!-- Alternate Address -->
          <ng-container *ngIf="row.payeeOverride?.address1">
            <gc-special-handling-display-line
              [payeeOverride]="row.payeeOverride"
              [isInternational]="isInternational"
              [showName]="row.processor === ProcessingType.Client"
              [isClientProcessing]="row.processor === ProcessingType.Client">
            </gc-special-handling-display-line>
          </ng-container>
          <!-- Designation -->
          <ng-container *ngIf="row.paymentDesignation || designation">
              <small class="d-block">
                <strong>
                  <yc-i18n
                    key="GLOBAL:textDesignation"
                    defaultValue="Designation">
                  </yc-i18n>:
                </strong>
                {{ row.paymentDesignation?  row.paymentDesignation : designation }}
              </small>
            </ng-container>
            <br>
            <!-- Notes -->
            <ng-container *ngIf="row.notes">
              <small class="d-block">
                <strong>
                  <yc-i18n
                    key="GLOBAL:NOTES"
                    defaultValue="Notes">
                  </yc-i18n>:
                </strong>
                <span [innerHTML]="row.notes | escapeHtml"></span>
              </small>
            </ng-container>
          </ng-container>
      </ng-container>
      </yc-table>
    </div>
  </ng-container>
</yc-accordion>
